import React, { useEffect, useState } from "react";
import "./ProductSpecification.css";
import Select_Dropdown_holder from "../../../Common-Component/Select_Dropdown_holder/Select_Dropdown_holder";
import { useDispatch, useSelector } from "react-redux";
import { findCombination } from "../../../../features/products/productsSlice";
import { Controller, useForm, useWatch } from "react-hook-form";

const specifications = [
  "Materials",
  "Lamination",
  "Orientation",
  "Printing Location",
  "Quantity",
];

const options = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
];

const ProductSpecification = ({
  combination,
  setCombination,
  setError,
  product,
}) => {
  const dispatch = useDispatch();

  const handleMaterialChange = (selected) => {
    setValue("material_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleLaminationChange = (selected) => {
    setValue("lamination_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleOrientationChange = (selected) => {
    setValue("orientation_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleEnvelopeChange = (selected) => {
    setValue("envelop_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handlePrintLocationChange = (selected) => {
    setValue("print_location_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleSizeChange = (selected) => {
    setValue("size_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleRoundCornerhange = (selected) => {
    setValue("round_corner", selected?.value === "Yes" ? 1 : 0);
    handleSubmit(onSubmit)();
  };

  const handleQuantityhange = (selected) => {
    setValue("quantity_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
  
    
    const res = await dispatch(findCombination(data));
    if (res?.payload?.errors) {
      setError(res?.payload?.errors);
    }
    await setCombination(res?.payload?.data);

  
  };

  useEffect(() => {
    if (product?.Product_Combinations?.length) {
      reset(product.Product_Combinations[0]);
      handleSubmit(onSubmit)();
      // const res= dispatch(findCombination(product.Product_Combinations[0]))

      // setCombination(res?.payload?.data);
     
    }
  }, [product, reset]);

 
  return (
    <section className="ProductSpecification">
      {/* {specifications.map((spec, index) => ( */}
      {/* {product?.Category?.material && <div className="specification_container">
        <div className="row align-items-center">
          <div className="col-4">
            <p className="specification_heading">Materials</p>
          </div>
          <div className="col-8">
            <Select_Dropdown_holder
              option={product?.Product_Combinations?.map((val) => ({
                value: val?.Material?.id,
                label: val?.Material?.name,
              }))}
              handleSubmit={handleSubmit }
              control={control}
              handleChange={handleMaterialChange}
            />
          </div>
        </div>
      </div>} */}

      <form onSubmit={handleSubmit(onSubmit)}>
        {product?.Category?.material && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Materials</p>
              </div>
              <div className="col-8">
                <Controller
                  name="material_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                      {...field}
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.material_id, 
                            { value: val?.material_id, label: val?.Material?.name }
                          ])
                        ).values()
                      ]}
                      
                      handleChange={handleMaterialChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {product?.Category?.lamination && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Lamination</p>
              </div>
              <div className="col-8">
                <Controller
                  name="lamination_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                     
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.lamination_id, 
                            { value: val?.lamination_id, label: val?.Lamination?.name }
                          ])
                        ).values()
                      ]}
                      
                      handleChange={handleLaminationChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}
        {product?.Category?.orientation && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Orientation</p>
              </div>
              <div className="col-8">
                <Controller
                  name="orientation_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                      
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.orientation_id, 
                            { value: val?.orientation_id, label: val?.Orientation?.name }
                          ])
                        ).values()
                      ]}
                      
                      handleChange={handleOrientationChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}
        {product?.Category?.printing_location && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Printing Location</p>
              </div>
              <div className="col-8">
                <Controller
                  name="print_location_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                      
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.print_location_id, 
                            { value: val?.print_location_id, label: val?.PrintingLocation?.name }
                          ])
                        ).values()
                      ]}
                      
                      handleChange={handlePrintLocationChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}
        {product?.Category?.quantity && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Quantity</p>
              </div>
              <div className="col-8">
                <Controller
                  name="quantity_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                     
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.quantity_id, 
                            { value: val?.quantity_id, label: val?.Qty?.name }
                          ])
                        ).values()
                      ]}

                      handleChange={handleQuantityhange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {product?.Category?.size && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Size</p>
              </div>
              <div className="col-8">
                <Controller
                  name="size_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                      
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.size_id, 
                            { value: val?.size_id, label: val?.Size?.name }
                          ])
                        ).values()
                      ]}
                      handleChange={handleSizeChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {product?.Category?.envelope && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Envelope</p>
              </div>
              <div className="col-8">
                <Controller
                  name="envelope_id" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                     
                      option={[
                        ...new Map(
                          product?.Product_Combinations?.map((val) => [
                            val?.envelope_id, 
                            { value: val?.envelope_id, label: val?.Envelope?.name }
                          ])
                        ).values()
                      ]}
                      handleChange={handleEnvelopeChange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {product?.Category?.round_corner && (
          <div className="specification_container">
            <div className="row align-items-center">
              <div className="col-4">
                <p className="specification_heading">Round Corner</p>
              </div>
              <div className="col-8">
                <Controller
                  name="round_corner" // Form field name
                  control={control}
                  render={({ field }) => (
                    <Select_Dropdown_holder
                      option={options}
                      handleChange={handleRoundCornerhange}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        )}
      </form>
      {/* ))} */}
    </section>
  );
};

export default ProductSpecification;
